import { createFileRoute } from "@tanstack/react-router";
import { AdminAuditPage } from "@/features/admin/audit";

export const Route = createFileRoute("/admin/audit")({
  head: () => ({ meta: [{ title: "Audit log · Admin · Malfak" }] }),
  component: AdminAuditPage,
});
